import { render, staticRenderFns } from "./Passengers.vue?vue&type=template&id=5da6a05c&scoped=true"
import script from "./Passengers.vue?vue&type=script&lang=js"
export * from "./Passengers.vue?vue&type=script&lang=js"
import style0 from "./Passengers.vue?vue&type=style&index=0&id=5da6a05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da6a05c",
  null
  
)

export default component.exports